import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, switchMap, take, takeWhile, tap } from 'rxjs/operators';
import { getGetting, getCustomerById } from '@appRoot/core/customer/ngrx-store/selectors/customer.selectors';
import { GetById } from '@appRoot/core/customer/ngrx-store/actions/customer.actions';


export const loadCustomerById = (store: Store<any>, id: number, maxAttempts: number = 3): Observable<any> => {
    return store.pipe(
        select(getGetting),
        filter(loading => !loading),
        switchMap(loading => store.pipe(select(getCustomerById(id)))),
        take(maxAttempts),
        takeWhile(e => !e),
        tap(e => store.dispatch(new GetById(id))),
    );
};
